<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-28 15:05:40
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-04-28 14:49:03
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/linkmec/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">
    <div class="ruleBtn" @click="ruleDialog">活动规则</div>
    <mt-swipe :auto="3000" class="swipeWrapper" ref="swipeWrapper">
      <mt-swipe-item v-for="(item, index) in imgList" :key="index">
        <div class="img-box">
          <div class="img">
            <img :src="item" alt="" />
          </div>
        </div>
      </mt-swipe-item>
    </mt-swipe>
    <div class="box">
      <appoint></appoint>
    </div>
  </div>
</template>
<script>
// import Home from './home.vue'
import showDialog from './dialog/gift';
import policyDialog from './dialog/policy/index';
import appoint from './appoint.vue';
import submitDialog from './dialog/gift2/index';
import ruleDialog from './dialog/ruleDialog/index'
export default {
  components: {
    appoint,
  },
  data() {
    let imgList = [
        'https://source.qunarzz.com/site/images/wns/20230419-wld-1.png',
        'https://source.qunarzz.com/site/images/wns/20230419-wld-2.png',
        'https://source.qunarzz.com/site/images/wns/20230419-wld-3.png',
        'https://source.qunarzz.com/site/images/wns/20230419-wld-4.png',
    ];
    if(+new Date()>+new Date('2023/05/01 00:00:00')){
      imgList[0] = 'https://source.qunarzz.com/site/images/wns/20230428-shijianchen-wld-banner.jpg'
    }
    if(this.$route.query.type == 'test'){
      imgList[0] = 'https://source.qunarzz.com/site/images/wns/20230428-shijianchen-wld-banner.jpg'
    }
    return {
      imgList: imgList,
      imgList2: [
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l1.png',
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l2.png',
        'https://source.qunarzz.com/site/images/wns/20220629-shijianchen-l3.png',
      ],
      name: '',
      phone: '',
      urlList: [
        'https://d.qunar.com/Kwh4ij',
        'https://touch.travel.qunar.com/h5/topic/comment/29723605?showType=share&bd_source=app_personal_entrance',
        'https://touch.travel.qunar.com/h5/topic/comment/29669712?showType=share&bd_source=b_order_user',
      ],
    };
  },
  methods: {
    showDialog() {
      showDialog({});
    },
    ruleDialog:ruleDialog,
    policy() {
      policyDialog({});
    },
    jump() {
      if (hysdk.sniff.scheme) {
        location.href = hysdk.sniff.scheme + `://sight/detail?id=3839021180`;
      } else {
        location.href =
          'http://touch.piao.qunar.com/touch/detail.htm?id=3839021180';
      }
    },
    submit() {
      var reg = /^1[3456789]\d{9}$/gi;
      if (!this.name) {
        this.$dialog.alert({
          message: '请输入姓名',
        });
        return;
      } else if (this.phone == '') {
        this.$dialog.alert({
          message: '请输入手机号',
        });
      } else if (!reg.test(this.phone)) {
        this.$dialog.alert({
          message: '请输入正确的手机号',
        });
      }
      this.$axios
        .post('/keepInfo/keepInfoLinKe', {
          name: this.name,
          phone: this.phone,
        })
        .then((res) => {
          if (res.code == 200) {
            submitDialog({});
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
    },
  },
  mounted() {
    new Swiper('.swiper-container', {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      loop: true, // 循环模式选项
    });
  },
};
</script>
<style lang='less' scoped='true'>
.ruleBtn{
  position: absolute;
  right:10px;
  top:464px;
  padding:6px 12px;
  background-color: rgba(0,0,0,.3);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-size: 12px;
  color: #fff;
}
#container{
  min-height: 971px;
  background: url(https://source.qunarzz.com/site/images/wns/20230419-shijianchen-bg.png) no-repeat;
  background-size: 100% auto;
}
.swipeWrapper {
  height: 494px;
  box-sizing: border-box;
  /deep/ .mint-swipe-indicators{
    display: none;
  }
}
.img-box {
  position: relative;
  .img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
.box {
  // position: absolute;
  width: 100%;
  padding-left:30px;
  padding-right:30px;
  box-sizing: border-box;
  // left: 50%;
  // transform: translateX(-50%);
}
.title {
  height: 24px;
}
</style>